import type { IconSvgObject } from './types';

const SquareActivityIcon: IconSvgObject = [
  ["path", { d: "M4.31021 19.682C2.99219 18.364 2.99219 16.2426 2.99219 12C2.99219 7.75736 2.99219 5.63604 4.31021 4.31802C5.62823 3 7.74955 3 11.9922 3C16.2348 3 18.3561 3 19.6742 4.31802C20.9922 5.63604 20.9922 7.75736 20.9922 12C20.9922 16.2426 20.9922 18.364 19.6742 19.682C18.3561 21 16.2348 21 11.9922 21C7.74955 21 5.62823 21 4.31021 19.682Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5.99219 12H8.49219L10.4922 8L13.4922 16L15.4922 12H17.9922", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SquareActivityIcon;
